module.exports = __webpack_public_path__ + "img/season-pass-2.a6995eb8.webp";